// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__XtzDH","icon":"Card_icon__zZEzh","mo":"Card_mo__vQ9gL"};